<script>
import WarehouseArea from "@/router/views/property/settings-template/warehouse-component/area-modal.vue";

export default {
  name: "warehouse-area",
  components: {
    WarehouseArea
  },
  props: {
    areaRow: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      areaChildren: [],
      itemVisible: false,
      loading: false
    };
  },
  methods: {
    dropData(row) {
      this.$emit("dropData", row);
    },
    showAreaChildren() {
      if (!this.areaRow.withChild) return;

      this.itemVisible = !this.itemVisible;
      if (this.itemVisible) {
        this.loading = true;
        setTimeout(() => {
          this.$store
            .dispatch(
              "propertywarehouse/GetLocationAreaByParent",
              this.areaRow.id
            )
            .then((res) => {
              this.loading = false;
              this.areaChildren = res.data;
            })
            .catch(() => {
              this.loading = false;
              this.showToast("Something went wrong - Areas!", "error");
            });
        }, 1000);
      }
    }
  }
};
</script>

<template>
  <div>
    <div>
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-3">
          <div @click="showAreaChildren()">
            <i
              class="bx bx-chevron-right rotate font-size-20 cursor-pointer"
              :class="{
                'rotate-90': itemVisible
              }"
            ></i>
          </div>
          <div>
            <b class="text-white">{{ areaRow.areaName }}</b>
            <div>
              {{ areaRow.areaDescription }}
            </div>
          </div>
        </div>
        <button
          type="button"
          @click="dropData(areaRow)"
          class="ms-2 btn btn-sm btn-info d-flex align-items-center"
        >
          <i class="bx bx-check me-2 fs-6"></i>Select
        </button>
      </div>
      <hr />
    </div>
    <b-collapse :visible="itemVisible" role="tabpanel">
      <div v-if="itemVisible" class="mt-2 ms-4">
        <div v-if="loading">
          <div class="d-flex align-items-center mb-5">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <span>Loading...</span>
          </div>
        </div>
        <div v-else-if="areaChildren.length > 0">
          <div v-for="areaRow in areaChildren" :key="areaRow.id">
            <warehouse-area
              :areaRow="areaRow"
              @dropData="dropData($event)"
            ></warehouse-area>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
